import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CatalogCheckboxFilter, Product } from "./catalogApi";
import { getLang } from '@/helpers/getLang';

export const vacancyApi = createApi({
    reducerPath: 'vacancyApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getVacancyFilters: builder.query<CatalogCheckboxFilter[], void>({
            query: () => ({ url: `/articles/vacancies/filters?lang=${getLang()}` })
        }),
        getVacanciesByFilter: builder.mutation<Product[], any>({
            query: (body) => ({ url: `/articles/vacancies/pages/filter/count?lang=${getLang()}`, method: "POST", body: body })
        })
    })
})

export const { useGetVacancyFiltersQuery, useGetVacanciesByFilterMutation } = vacancyApi
